import { Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { App_FormFieldMarqueurs } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-sketch-legende',
  templateUrl: './c-sketch-legende.component.html',
  styleUrls: ['./c-sketch-legende.component.scss'],
})
export class CSketchLegendeComponent  implements OnInit {
  @Input({ required: true }) fieldMarqueurs!: App_FormFieldMarqueurs;
  @Input({ required: true }) sourceMarqueurs: any;
  @Input({ required: true }) modeShow!: boolean;
  
  @Output() modifiedValue = new EventEmitter<{
    label: string,
    description: string,
    index: number
  }>();

  fixedLegend: { label: string, description: string | undefined | null }[] = [];

  ongoingEditedElements: number[] = [];

  constructor() { }

  ngOnInit() {
    this.defineFixedLegend(this.fieldMarqueurs);
  }

  defineFixedLegend(fieldMarqueurs: App_FormFieldMarqueurs) {
    if (fieldMarqueurs) {
      const marqueursDatas = fieldMarqueurs.datas;
      if (marqueursDatas !== null && marqueursDatas !== undefined) {
        const fixedLegend = Object.entries(marqueursDatas).map(([key, entry]) => ({
          label: key,
          description: entry
        }));
        this.fixedLegend = fixedLegend;
      }
    }
  }

  toggleEditableMode(index: number) {
    if (this.ongoingEditedElements.includes(index)) {
      this.ongoingEditedElements = this.ongoingEditedElements.filter(e => e !== index);
    } else {
      this.ongoingEditedElements = [...this.ongoingEditedElements, index];
    }
  }

  // editLabel($event: any, legendElement: { label: string, description: string, index: number }, index: number) {
  //   const value = $event.detail.value;
  //   if (typeof value === 'string' && value.length > 0) {
  //     const label = value.trim().slice(0,3).trim();
  //     this.modifiedValue.emit({
  //       label,
  //       description: legendElement.description,
  //       index
  //     });
  //     const inputInTarget = this.findInput($event.target);
  //     if (inputInTarget) {
  //       requestAnimationFrame(() => {
  //         inputInTarget.value = label
  //       });
  //     }
  //   }
  // }

  // findInput(elem: any): any | undefined {
  //   const childNodes = elem.childNodes as NodeList;
  //   const children: Node[] = [];
  //   childNodes.forEach(child => children.push(child));
  //   for (const child of children) {
  //     if (child.nodeName === 'INPUT') {
  //       return child;
  //     } else {
  //       const found = this.findInput(child);
  //       if (found !== undefined) {
  //         return found
  //       }
  //     }
  //   }
  //   return undefined;
  // }

  editDescription($event: any, legendElement: { label: string, description: string, index: number }, index: number) {
    const value = $event.detail.value;
    if (typeof value === 'string' && value.length > 0) {
      const description = value.trim();
      this.modifiedValue.emit({
        label: legendElement.label,
        description,
        index
      });
    }
  }

  trackByIndex(index: number, item: any) {
    return index;
  }
}

@Pipe({
  name: 'elementEditionOn'
})
export class ElementEditionOnPipe implements PipeTransform {
  transform(elementIndex: number, ongoingEditedElements: number[]): boolean {
    return ongoingEditedElements.includes(elementIndex);
  }
}

@Pipe({
  name: 'sourceMarqueursIntoLegend'
})
export class SourceMarqueursIntoLegendPipe implements PipeTransform {
  transform(sourceMarqueurs: any, fixedLegend: { label: string, description: string | undefined | null }[]): { label: string, description: string, index: number }[] {
    if (Array.isArray(sourceMarqueurs)) {
      const toDisplay = [...fixedLegend, ...sourceMarqueurs.slice(fixedLegend.length)].map((marqueur, index) => ({
        label: typeof marqueur.label === 'string' ? marqueur.label : '',
        description: typeof marqueur.description === 'string' ? marqueur.description : '',
        index
      }));
      return toDisplay;
    } else {
      const toDisplay = fixedLegend.map((marqueur, index) => ({
        label: typeof marqueur.label === 'string' ? marqueur.label : '',
        description: typeof marqueur.description === 'string' ? marqueur.description : '',
        index
      }));
      return toDisplay;
    }
  }
}
